import React, { useEffect, useState } from 'react';
import { Link, NavLink } from 'react-router-dom';
import AOS from 'aos';
import 'aos/dist/aos.css';
import { FaBlog } from 'react-icons/fa';
import { AiOutlineHome } from 'react-icons/ai';
import { ImCross } from 'react-icons/im';
import { BsTelephoneForward, BsPersonCircle } from 'react-icons/bs';
import { GiProgression } from 'react-icons/gi';
import { HiLanguage } from 'react-icons/hi2';
import { GoProjectSymlink } from 'react-icons/go';
import fahim from '../../images/fahim/A.jpg';
import './Header3.css'
import { useLanguage } from '../../context/LanguageContext';












const Header3 = () => {



    useEffect(() => {
        AOS.init({
            duration: 1000
        })
    }, [])








    const [openSideBar, setOpenSideBar] = useState(true)
    const handleOpenSideBar = () => {
        setOpenSideBar(!openSideBar);
        window.scrollTo(0, 0)
    }




    const [showIcon, setShowIcon] = useState(true);
    // useEffect(() => {
    //     const handleScroll = () => {
    //         if (window.pageYOffset === 0) {
    //             setShowIcon(true);
    //         } else {
    //             setShowIcon(false);
    //         }
    //     };
    //     window.addEventListener('scroll', handleScroll);
    //     return () => {
    //         window.removeEventListener('scroll', handleScroll);
    //     };
    // }, []);

















    const { changeLanguage, language } = useLanguage();


    const [buttonText, setButtonText] = useState('বাংলা');
    const toggleLanguage = () => {
        if (language === 'english') {
            changeLanguage('bangla');
            setButtonText('ENGLISH');
        } else {
            changeLanguage('english');
            setButtonText('বাংলা');
        }
    };


    const [english, setEnglish] = useState(true);
    const [bangla, setBangla] = useState(false);
    const EnglishToBanglaLanguage = () => {
        changeLanguage('bangla');
        setEnglish(false);
        setBangla(true)
    };

    const BanglaToEnglishLanguage = () => {
        changeLanguage('english');
        setEnglish(true);
        setBangla(false)
    };









    //Code for making the header sticky while scrolling
    const [sticky, setSticky] = useState("");
    useEffect(() => {
        window.addEventListener("scroll", isSticky);
        return () => {
            window.removeEventListener("scroll", isSticky);
        };
    }, []);


    /* Method that will fix header after a specific scrollable. Must include the isSticky Class in the css file. Otherwise the header will not be sticky*/
    const isSticky = () => {
        const scrollTop = window.scrollY;
        const stickyClass = scrollTop >= 500 ? "is-sticky" : "";
        setSticky(stickyClass);
    };
















    return (

        <div className='print:hidden'>
            <div>

                {/* <div className=' mt-4 flex justify-end items-center gap-x-2 lg:px-10 px-0'>
                    <HiLanguage className='text-4xl text-white'></HiLanguage>
                    <div>
                        <button className='font-bold text-rose-500  ' onClick={toggleLanguage}>{buttonText}</button>
                    </div>
                </div> */}


                <div className=' mt-[15px] flex lg:justify-end md:justify-center sm:justify-center justify-center items-center gap-x-2 lg:px-5 px-0 lg:mr-[20px] mr-0   lg:mb-1 md:mb-0 sm:mb-2 mb-2'>
                    <HiLanguage className='md:text-3xl lg:text-[27px] text-3xl text-white'></HiLanguage>
                    <div className='flex  justify-start items-center gap-x-2'>
                        <button className={`cursor-pointer lg:text-[14px] md:text-lg text-[15px] font-semibold ${english ? 'text-amber-500' : 'text-white'}`} onClick={BanglaToEnglishLanguage}>ENGLISH</button>
                        <p className='md:text-[20px] text-[17px] text-white font-bold -mt-1'> | </p>
                        <button className={`cursor-pointer lg:text-[14px] md:text-lg  text-[15px] font-semibold ${bangla ? 'text-amber-500' : 'text-white'}`} onClick={EnglishToBanglaLanguage}>বাংলা</button>

                    </div>
                </div>








                <div className={`${sticky} `}>
                    <div className={`top-0 sticky z-50 ${sticky ? 'lg:-mt-0 mt-0 bg-[#020522] text-white lg:py-[7px] md:py-[12px] py-[8px]   lg:px-[20px] px-0' : ' lg:-mt-2 mt-0 bg-transparent'}`}>
                        <div className={`navbar lg:px-4 px-0`}>
                            <div className="navbar-start ">
                                <div className="dropdown ">

                                    {
                                        !openSideBar ?
                                            <ImCross onClick={handleOpenSideBar} className={`cursor-pointer md:ml-2 ml-1 h-8 w-8 md:h-10 md:w-8  md:fixed relative md:top-8 md:right-4 lg:hidden block text-red-500  md:mr-0 mr-2  `}></ImCross>
                                            :
                                            <label onClick={handleOpenSideBar} className={`cursor-pointer md:fixed relative md:right-4 lg:hidden block text-white ${sticky ? ' text-white md:text-white md:top-8' : 'md:top-[52px] '} `}>
                                                <svg xmlns="http://www.w3.org/2000/svg" className="md:ml-2 ml-1 h-10 w-10 md:h-10 md:w-10  " fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h8m-8 6h16" /></svg>
                                            </label>
                                    }



                                    {/* //Smaller device */}
                                    <ul tabIndex={0} className="menu  dropdown-content mt-1 p-2 shadow bg-base-100 rounded-box w-52 text-white">
                                        {/* <NavLink to='/'  className={({ isActive }) => isActive ? 'active' : undefined}></NavLink> */}
                                        <NavLink to='/' className='hover:text-rose-500 font-semibold my-1'>Home</NavLink>
                                        <NavLink to='/projects' className='hover:text-rose-500 font-semibold my-1'>Projects</NavLink>
                                        <NavLink to='/skills' className='hover:text-rose-500 font-semibold my-1'>Skills</NavLink>
                                        <NavLink to='/allBlogs' className='hover:text-rose-500 font-semibold my-1'>Blogs</NavLink>
                                        <NavLink to='aboutMe' className='hover:text-rose-500 font-semibold my-1'>About Me</NavLink>
                                        <NavLink to='/contact' className='hover:text-rose-500 font-semibold my-1'>Contact Me</NavLink>
                                        <div className='flex justify-center items-center py-1 px-1 rounded-sm bg-gradient-to-r from-violet-900 to-pink-700 mt-1 mb-3 ' title='View Resume '>
                                            {/* <AiOutlineFileText className=' text-white'></AiOutlineFileText> */}
                                            <a href='https://drive.google.com/file/d/1euk-NTlg_IWtuxbbpdiPP3Mcfq7gvNAx/view?usp=sharing' target='blank' className='pl-3 pr-2 text-[17px] text-white'>My Resume</a>
                                        </div>
                                    </ul>
                                </div>




                                {
                                    language === 'english' ?
                                        <Link to='/' className='block'>
                                            <Link to='/' className="normal-case md:text-[30px] sm:text-[27px] text-[27px] font-bold ml-[20px] md:ml-6 lg:ml-4 font-mono ">Fahim<span className='text-rose-600 md:text-[30px] text-[27px] ml-2 font-bold font-mono'>Faysal</span></Link>
                                            <h1 className='lg:-mt-[5px] md:mt-0 -mt-[5px] text-[9px] sm:text-[9px] md:text-[13px] lg:text-[10px] text-center tracking-[6px] sm:tracking-[6px] md:tracking-[5px] lg:tracking-[6px] md:ml-3 lg:ml-4 sm:ml-[17px] ml-[17px]'><span className='text-rose-600 font-bold'>WEB</span> DEVELOPER</h1>
                                        </Link>
                                        :

                                        <Link to='/' className='mt-2 block'>
                                            <Link to='/' className="normal-case md:text-[30px]  text-[28px] font-bold ml-[18px] md:ml-6 lg:ml-4 font-mono ">ফাহিম<span className='text-rose-600 md:text-[30px] text-[28px] ml-2 font-bold font-mono'>ফয়সাল</span></Link>
                                            <h1 className='text-[12px] sm:text-[12px] md:text-[13px] lg:text-[13px] text-center tracking-[1px] sm:tracking-[1px] md:tracking-[5px] lg:tracking-[3px] md:ml-3 lg:ml-4 sm:ml-[14px] ml-[16px] lg:-mt-2 md-mt-2 -mt-1'><span className='text-rose-600 font-bold mr-1'>ওয়েব</span>ডেভেলপার</h1>
                                        </Link>
                                }


                            </div>






                            {/* //Large device */}
                            {
                                language === 'english' ?
                                    <div className="lg:-ml-5 ml-0 navbar-end hidden lg:flex">
                                        <ul className="menu menu-horizontal px-1 text-[15px]  text-white">
                                            {/* <NavLink to='/' className={({ isActive }) => isActive ? 'active' : undefined}></NavLink> */}
                                            <NavLink to='/' className={({ isActive }) => isActive ? 'active px-4 text-[16px] hover:text-amber-500 mt-1 font-semibold ' : 'px-4 text-[16px] hover:text-rose-500 mt-1 font-semibold  hover:duration-300 hover:delay-150 transition ease-out hover:-translate-y-1 '}>Home</NavLink>
                                            <NavLink to='/projects' className={({ isActive }) => isActive ? 'active px-4 text-[16px] hover:text-amber-500 mt-1 font-semibold ' : 'px-4 text-[16px] hover:text-rose-500 mt-1 font-semibold  hover:duration-300 hover:delay-150 transition ease-out hover:-translate-y-1 '}>Projects</NavLink>
                                            <NavLink to='/skills' className={({ isActive }) => isActive ? 'active px-4 text-[16px] hover:text-amber-500 mt-1 font-semibold ' : 'px-4 text-[16px] hover:text-rose-500 mt-1 font-semibold  hover:duration-300 hover:delay-150 transition ease-out hover:-translate-y-1 '}>Skills</NavLink>
                                            <NavLink to='/allBlogs' className={({ isActive }) => isActive ? 'active px-4 text-[16px] hover:text-amber-500 mt-1 font-semibold ' : 'px-4 text-[16px] hover:text-rose-500 mt-1 font-semibold  hover:duration-300 hover:delay-150 transition ease-out hover:-translate-y-1 '}>Blogs</NavLink>
                                            <NavLink to='/aboutMe' className={({ isActive }) => isActive ? 'active px-4 text-[16px] hover:text-amber-500 mt-1 font-semibold ' : 'px-4 text-[16px] hover:text-rose-500 mt-1 font-semibold  hover:duration-300 hover:delay-150 transition ease-out hover:-translate-y-1 '}>About</NavLink>
                                            <NavLink to='/contact' className={({ isActive }) => isActive ? 'active px-4 text-[16px] hover:text-amber-500 mt-1 font-semibold ' : 'px-4 text-[16px] hover:text-rose-500 mt-1 font-semibold  hover:duration-300 hover:delay-150 transition ease-out hover:-translate-y-1 '}>Contact</NavLink>

                                            {
                                                sticky
                                                    ?
                                                    <div className=' flex justify-center items-center py-[6px] px-1 rounded-sm color-changing-resume-button-sticky md:ml-4 ml-0   hover:scale-105 hover:duration-300 hover:ease-in-out hover:delay-150' title='View My Resume'>
                                                        <a href='https://drive.google.com/file/d/1euk-NTlg_IWtuxbbpdiPP3Mcfq7gvNAx/view?usp=sharing' target='blank' className='pl-3 pr-2 text-[16px] text-white'>My Resume</a>
                                                    </div>
                                                    :
                                                    <div className=' flex justify-center items-center py-[6px] px-1 rounded-sm color-changing-resume-button-notSticky md:ml-4 ml-0   hover:scale-105 hover:duration-300 hover:ease-in-out hover:delay-150' title='View My Resume'>
                                                        <a href='https://drive.google.com/file/d/1euk-NTlg_IWtuxbbpdiPP3Mcfq7gvNAx/view?usp=sharing' target='blank' className='pl-3 pr-2 text-[16px] text-white'>My Resume</a>
                                                    </div>
                                            }
                                        </ul>
                                    </div>
                                    :
                                    <div className="lg:-ml-6 ml-0 navbar-end hidden lg:flex ">
                                        <ul className="menu menu-horizontal px-1 text-[15px] text-white  ">
                                            {/* <NavLink to='/' className={({ isActive }) => isActive ? 'active' : undefined}></NavLink> */}
                                            <NavLink to='/' className={({ isActive }) => isActive ? 'active px-4 text-[15px] hover:text-amber-500 mt-1 font-semibold ' : 'px-4 text-[15px] hover:text-rose-500 mt-1 font-semibold  hover:duration-300 hover:delay-150 transition ease-out hover:-translate-y-1 '}>হোম</NavLink>
                                            <NavLink to='/projects' className={({ isActive }) => isActive ? 'active px-4 text-[15px] hover:text-amber-500 mt-1 font-semibold ' : 'px-4 text-[15px] hover:text-rose-500 mt-1 font-semibold  hover:duration-300 hover:delay-150 transition ease-out hover:-translate-y-1 '}>প্রজেক্ট</NavLink>
                                            <NavLink to='/skills' className={({ isActive }) => isActive ? 'active px-4 text-[15px] hover:text-amber-500 mt-1 font-semibold ' : 'px-4 text-[15px] hover:text-rose-500 mt-1 font-semibold  hover:duration-300 hover:delay-150 transition ease-out hover:-translate-y-1 '}>দক্ষতা</NavLink>
                                            <NavLink to='/allBlogs' className={({ isActive }) => isActive ? 'active px-4 text-[15px] hover:text-amber-500 mt-1 font-semibold ' : 'px-4 text-[15px] hover:text-rose-500 mt-1 font-semibold  hover:duration-300 hover:delay-150 transition ease-out hover:-translate-y-1 '}>ব্লগ</NavLink>
                                            <NavLink to='/aboutMe' className={({ isActive }) => isActive ? 'active px-4 text-[15px] hover:text-amber-500 mt-1 font-semibold ' : 'px-4 text-[15px] hover:text-rose-500 mt-1 font-semibold  hover:duration-300 hover:delay-150 transition ease-out hover:-translate-y-1 '}>আমি</NavLink>
                                            <NavLink to='/contact' className={({ isActive }) => isActive ? 'active px-4 text-[15px] hover:text-amber-500 mt-1 font-semibold ' : 'px-4 text-[15px] hover:text-rose-500 mt-1 font-semibold  hover:duration-300 hover:delay-150 transition ease-out hover:-translate-y-1 '}>যোগাযোগ</NavLink>
                                            {
                                                sticky
                                                    ?
                                                    <div className='text-[15px] flex justify-center items-center py-[6px] px-1 rounded-sm color-changing-resume-button-sticky md:ml-4 ml-0' title='View Resume '>
                                                        <a href='https://drive.google.com/file/d/1euk-NTlg_IWtuxbbpdiPP3Mcfq7gvNAx/view?usp=sharing' target='blank' className='pl-3 pr-2 text-[15px] text-white'>আমার বৃত্তান্ত</a>
                                                    </div>
                                                    :
                                                    <div className='text-[15px] flex justify-center items-center py-[6px] px-1 rounded-sm color-changing-resume-button-notSticky md:ml-4 ml-0' title='View Resume '>
                                                        <a href='https://drive.google.com/file/d/1euk-NTlg_IWtuxbbpdiPP3Mcfq7gvNAx/view?usp=sharing' target='blank' className='pl-3 pr-2 text-[15px] text-white'>আমার বৃত্তান্ত</a>
                                                    </div>
                                            }
                                        </ul>
                                    </div>
                            }

                        </div>
                    </div>
                </div>



            </div>

















            {
                !openSideBar &&
                <>




                    {/* <div className='md:absolute right-[322px] animation lg:mt-0 md:-mt-[28px] ' data-aos='md:fade-right'>
                        <div className='lg:hidden xl:hidden md:hidden hidden z-50 absolute animation    md:ml-0 lg:ml-0 -ml-[7px]     md:mt-0 -mt-2 lg:mt-0' data-aos='fade-right'>
                            <div className="h-[510px] md:h-[510px] p-3 space-y-2 sm:w-56 md:w-80 w-60  bg-[#040a47] dark:text-gray-100 px-4">
                                <div className="divide-y ">
                                    <ul className="pt-2 pb-2 text-sm -mt-2">
                                        <div onClick={() => setOpenSideBar(!openSideBar)} className=' md:ml-2 sm:ml-2 ml-2 flex justify-center items-center py-[10px] px-1 rounded-sm bg-gradient-to-r from-violet-900 to-pink-700 md:mt-4 mt-4 mb-2' title='View Resume '>
                                            <a href='https://drive.google.com/file/d/1euk-NTlg_IWtuxbbpdiPP3Mcfq7gvNAx/view?usp=sharing' target='blank' className='pl-3 pr-2 text-[17px] text-white'>My Resume</a>
                                        </div>
                                        <Link onClick={() => setOpenSideBar(!openSideBar)} to='/' className="dark:bg-gray-800 dark:text-gray-50 ">
                                            <div className="mb-2 flex items-center p-2 space-x-3 rounded-md">
                                                <AiOutlineHome className='text-white text-[27px] md:text-3xl'></AiOutlineHome>
                                                <span className='text-white md:text-[20px] text-[17px] '>Home</span>
                                            </div>
                                        </Link>
                                        <Link onClick={() => setOpenSideBar(!openSideBar)} to='/projects' className="bg-gray-800 text-gray-50">
                                            <div className="mb-2 flex items-center p-2 space-x-3 rounded-md">
                                                <GoProjectSymlink className='text-white text-[27px] md:text-3xl'></GoProjectSymlink>
                                                <span className='text-white md:text-[20px] text-[17px]'>Projects</span>
                                            </div>
                                        </Link>
                                        <Link onClick={() => setOpenSideBar(!openSideBar)} to='/skills' className="dark:bg-gray-800 dark:text-gray-50 mb-3">
                                            <div className="mb-2 flex items-center p-2 space-x-3 rounded-md">
                                                <GiProgression className='text-white text-[27px] md:text-3xl'></GiProgression>
                                                <span className='text-white md:text-[20px] text-[17px]'>My Skills</span>
                                            </div>
                                        </Link>
                                        <Link onClick={() => setOpenSideBar(!openSideBar)} to='/allBlogs' className="dark:bg-gray-800 dark:text-gray-50">
                                            <div className="mb-2 flex items-center p-2 space-x-3 rounded-md">
                                                <FaBlog className='text-white text-[27px] md:text-3xl'></FaBlog>
                                                <span className='text-white md:text-[20px] text-[17px]'>Blogs</span>
                                            </div>
                                        </Link>
                                        <Link onClick={() => setOpenSideBar(!openSideBar)} to='/contact' className="dark:bg-gray-800 dark:text-gray-50">
                                            <div className="mb-2 flex items-center p-2 space-x-3 rounded-md">
                                                <BsTelephoneForward className='text-white text-[27px] md:text-3xl'></BsTelephoneForward>
                                                <span className='text-white md:text-[20px] text-[17px]'>Contact Me</span>
                                            </div>
                                        </Link>
                                        <Link onClick={() => setOpenSideBar(!openSideBar)} to='/aboutMe' className="dark:bg-gray-800 dark:text-gray-50">
                                            <div className="mb-2 flex items-center p-2 space-x-3 rounded-md">
                                                <div className="avatar ml-[1px]">
                                                    <div className="w-[34px] rounded-full">
                                                        <img className='mx-auto' src={fahim} alt='fahim' />
                                                    </div>
                                                </div>
                                                <span className='text-white md:text-[20px] text-[17px]'>About Me</span>
                                            </div>
                                        </Link>

                                        <Link to='/contact'>
                                            <div className='px-3 lg:mt-0 md:mt-12 mt-[60px] mb-10 w-full  mx-auto text-center cursor-pointer'>
                                                <button className=' text-lg w-full px-10 py-2 bg-lime-700 rounded-sm text-white'>Hire Me</button>
                                            </div>
                                        </Link>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div> */}







                    {/* Small and Medium Device er jonno Side Bar */}
                    <div className='w-full lg:mt-0 md:mt-5 mt-3' >
                        <div className='small-header-width mx-auto overflow-x-hidden px-2    absolute  z-50  lg:hidden xl:hidden md:block block   animation' data-aos='fade-right'>
                            <div className='bg-[#031133]  '>
                                <div className=" ">
                                    <ul className="pt-3 pb-3 text-sm mt-1">
                                        <div className='px-8 -ml-[16px]'>
                                            <div onClick={() => setOpenSideBar(!openSideBar)} className='  flex justify-center items-center py-[10px] rounded-sm color-changing-resume-button-small-device md:mt-4 mt-4 mb-2 ' title='View Resume '>
                                                <a href='https://drive.google.com/file/d/1euk-NTlg_IWtuxbbpdiPP3Mcfq7gvNAx/view?usp=sharing' target='blank' className='pl-3 pr-2 text-[17px] text-white'>{language === 'english' ? 'My Resume' : 'আমার বৃত্তান্ত'}</a>
                                            </div>
                                        </div>
                                        <Link onClick={() => setOpenSideBar(!openSideBar)} to='/' className="dark:bg-gray-800 dark:text-gray-50">
                                            <div className="mb-1 flex items-center px-[14px] py-2 space-x-3 rounded-md">
                                                <AiOutlineHome className='text-white text-[27px] md:text-3xl'></AiOutlineHome>
                                                <span className='text-white md:text-[20px] text-[17px] '>{language === 'english' ? 'Home' : 'হোম'}</span>
                                            </div>
                                        </Link>
                                        <Link onClick={() => setOpenSideBar(!openSideBar)} to='/projects' className="bg-gray-800 text-gray-50">
                                            <div className="mb-1 flex items-center px-[14px] py-2 space-x-3 rounded-md">
                                                <GoProjectSymlink className='text-white text-[27px] md:text-3xl'></GoProjectSymlink>
                                                <span className='text-white md:text-[20px] text-[17px]'>{language === 'english' ? 'Projects' : 'প্রজেক্ট সমূহ'}</span>
                                            </div>
                                        </Link>
                                        <Link onClick={() => setOpenSideBar(!openSideBar)} to='/skills' className="dark:bg-gray-800 dark:text-gray-50 mb-3">
                                            <div className="mb-1 flex items-center px-[14px] py-2 space-x-3 rounded-md">
                                                <GiProgression className='text-white text-[27px] md:text-3xl'></GiProgression>
                                                <span className='text-white md:text-[20px] text-[17px]'>{language === 'english' ? 'My Skills' : 'আমার দক্ষতা'}</span>
                                            </div>
                                        </Link>
                                        <Link onClick={() => setOpenSideBar(!openSideBar)} to='/allBlogs' className="dark:bg-gray-800 dark:text-gray-50">
                                            <div className="mb-1 flex items-center px-[14px] py-2 space-x-3 rounded-md">
                                                <FaBlog className='text-white text-[27px] md:text-3xl'></FaBlog>
                                                <span className='text-white md:text-[20px] text-[17px]'>{language === 'english' ? 'Blogs' : 'ব্লগ সমূহ'}</span>
                                            </div>
                                        </Link>
                                        <Link onClick={() => setOpenSideBar(!openSideBar)} to='/contact' className="dark:bg-gray-800 dark:text-gray-50">
                                            <div className="mb-1 flex items-center px-[14px] py-2 space-x-3 rounded-md">
                                                <BsTelephoneForward className='text-white text-[27px] md:text-3xl'></BsTelephoneForward>
                                                <span className='text-white md:text-[20px] text-[17px]'>{language === 'english' ? 'Contact Me' : 'যোগাযোগ করুন'}</span>
                                            </div>
                                        </Link>
                                        <Link onClick={() => setOpenSideBar(!openSideBar)} to='/aboutMe' className="dark:bg-gray-800 dark:text-gray-50">
                                            <div className="mb-2 flex items-center px-[14px] py-2 gap-x-2 rounded-md">
                                                <div className="avatar ml-[1px]">
                                                    <div className="w-[34px] rounded-full">
                                                        <img className='mx-auto' src={fahim} alt='fahim' />
                                                    </div>
                                                </div>
                                                <span className='text-white md:text-[20px] text-[17px]'>{language === 'english' ? 'About Me' : 'আমার সম্পর্কে'}</span>
                                            </div>
                                        </Link>
                                        <Link to='/contact'>
                                            <div className=' lg:mt-0 md:mt-6 sm:mt-4 mt-2 mb-4 sm:mb-2 lg:mb-0 md:mb-5 -ml-1 px-[19px] w-full  mx-auto text-center cursor-pointer'>
                                                <button className=' text-lg w-full px-16 py-2 bg-lime-700 rounded-sm text-white'>{language === 'english' ? 'Hire Me' : 'আমাকে বেছে নিন'}</button>
                                            </div>
                                        </Link>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>



                </>
            }




        </div>


    );
};

export default Header3;